<ng-container *ngIf="!isAuthOk">
  <router-outlet></router-outlet>
</ng-container>
<ng-container *ngIf="isAuthOk">
<header class="page-topbar" id="header">
  <div class="navbar navbar-fixed"> 
    <nav class="navbar-main navbar-color nav-collapsible sideNav-lock navbar-dark blue darken-4 no-shadow tatt-topbar">
      <div class="nav-wrapper">
        <!-- <div class="header-search-wrapper hide-on-med-and-down"><i class="material-icons">search</i>
          <input class="header-search-input z-depth-2" type="text" name="Search" placeholder="Explore Materialize">
        </div> -->
        <div class="header-search-wrapper hide-on-med-and-down">
          <!-- <h5 class="breadcrumbs-title mt-0 mb-0 tatt-topbar-h" style="color: #c9f937;"> -->
            <h5 class="breadcrumbs-title mt-0 mb-0 tatt-topbar-h">
            Whizzy People Counting
          </h5>
          <!-- <select>
            <option>Select Site</option>
            <option *ngFor="let rec of arrToggleStores; let iRec = index;">{{rec.name}}</option>
          </select> -->
        </div>

        <!-- <div  class="col s12 m6 header-search-wrapper" style="width: 200px;">
          <select (change)="toggleSelectDdl($event.target.value)">
            <option>Select Site</option>
            <option *ngFor="let rec of arrToggleStores; let iRec = index;">{{rec.name}}</option>
          </select>
        </div> -->
        
        <ul class="navbar-list right">
          <!-- <li class="hide-on-med-and-down"><a class="waves-effect waves-block waves-light translation-button" href="javascript:void(0);" data-target="translation-dropdown"><span class="flag-icon flag-icon-gb"></span></a>
            <ul class="dropdown-content" id="translation-dropdown" tabindex="0">
              <li tabindex="0"><a class="grey-text text-darken-1" href="#!"><i class="flag-icon flag-icon-gb"></i> English</a></li>
              <li tabindex="0"><a class="grey-text text-darken-1" href="#!"><i class="flag-icon flag-icon-fr"></i> French</a></li>
              <li tabindex="0"><a class="grey-text text-darken-1" href="#!"><i class="flag-icon flag-icon-cn"></i> Chinese</a></li>
              <li tabindex="0"><a class="grey-text text-darken-1" href="#!"><i class="flag-icon flag-icon-de"></i> German</a></li>
            </ul>
          </li> -->
          <li class="hide-on-med-and-down hide">
            <a (click)="toggleFullScreen()" class="waves-effect waves-block waves-light toggle-fullscreen" href="javascript:void(0);"><i class="material-icons">settings_overscan</i></a>
          </li>
          <!-- <li class="hide-on-large-only"><a class="waves-effect waves-block waves-light search-button" href="javascript:void(0);"><i class="material-icons">search</i></a></li> -->
          <!-- <li><a class="waves-effect waves-block waves-light notification-button" href="javascript:void(0);" data-target="notifications-dropdown"><i class="material-icons">notifications_none<small class="notification-badge">5</small></i></a>
            <ul class="dropdown-content" id="notifications-dropdown" tabindex="0">
              <li tabindex="0">
                <h6>NOTIFICATIONS<span class="new badge">5</span></h6>
              </li>
              <li class="divider" tabindex="0"></li>
              <li tabindex="0"><a class="grey-text text-darken-2" href="#!"><span class="material-icons icon-bg-circle cyan small">add_shopping_cart</span> A new order has been placed!</a>
                <time class="media-meta" datetime="2015-06-12T20:50:48+08:00">2 hours ago</time>
              </li>
              <li tabindex="0"><a class="grey-text text-darken-2" href="#!"><span class="material-icons icon-bg-circle red small">stars</span> Completed the task</a>
                <time class="media-meta" datetime="2015-06-12T20:50:48+08:00">3 days ago</time>
              </li>
              <li tabindex="0"><a class="grey-text text-darken-2" href="#!"><span class="material-icons icon-bg-circle teal small">settings</span> Settings updated</a>
                <time class="media-meta" datetime="2015-06-12T20:50:48+08:00">4 days ago</time>
              </li>
              <li tabindex="0"><a class="grey-text text-darken-2" href="#!"><span class="material-icons icon-bg-circle deep-orange small">today</span> Director meeting started</a>
                <time class="media-meta" datetime="2015-06-12T20:50:48+08:00">6 days ago</time>
              </li>
              <li tabindex="0"><a class="grey-text text-darken-2" href="#!"><span class="material-icons icon-bg-circle amber small">trending_up</span> Generate monthly report</a>
                <time class="media-meta" datetime="2015-06-12T20:50:48+08:00">1 week ago</time>
              </li>
            </ul>
          </li> -->

          

          <li>
            <a class="waves-effect waves-block waves-light profile-button adl" href="javascript:void(0);" data-target="adl-profile-icon">
              <span class="avatar-status avatar-online">
                <img src="./assets/img/logo/profile.logo.png" alt="avatar">
                <!-- <i></i> -->
              </span>
            </a>
            <ul class="dropdown-content right" id="adl-profile-icon" tabindex="0">
              <!-- <li tabindex="0"><a class="grey-text text-darken-1" href="user-profile-page.html"><i class="material-icons">person_outline</i> Profile</a></li>
              <li tabindex="0"><a class="grey-text text-darken-1" href="app-chat.html"><i class="material-icons">chat_bubble_outline</i> Chat</a></li>
              <li tabindex="0"><a class="grey-text text-darken-1" href="page-faq.html"><i class="material-icons">help_outline</i> Help</a></li>
              <li class="divider" tabindex="0"></li> -->
              <li tabindex="0"><a (click)="logout()" class="grey-text text-darken-1 right"><i class="material-icons">lock_outline</i> Logouts</a></li>
              <!-- <li tabindex="0"><a class="grey-text text-darken-1" href="user-login.html"><i class="material-icons">keyboard_tab</i> Logout</a></li> -->
            </ul>
          </li>
          <!-- <li><a class="waves-effect waves-block waves-light sidenav-trigger" href="#" data-target="slide-out-right"><i class="material-icons">format_indent_increase</i></a></li> -->
        </ul>
        <!-- translation-button-->
        
        <!-- notifications-dropdown-->
        
        <!-- profile-dropdown-->
        
      </div>
      <nav class="display-none search-sm">
        <div class="nav-wrapper">
          <form>
            <div class="input-field">
              <input class="search-box-sm" type="search" required="">
              <label class="label-icon" for="search"><i class="material-icons search-sm-icon">search</i></label><i class="material-icons search-sm-close">close</i>
            </div>
          </form>
        </div>
      </nav>
    </nav>
  </div>
</header>
<aside class="sidenav-main nav-expanded nav-lock nav-collapsible sidenav-light sidenav-active-square">
  <div class="brand-sidebar">
    <h1 class="logo-wrapper">
      <a (click)="menuItemSelect(0)" class="brand-logo darken-1" href="javascript:void(0);">
        <img class="hide-on-med-and-up" src="../assets/img/logo/logo.white.png?v=20231108" alt="materialize logo">
        <!-- <img class="hide-on-small-only" src="../assets/img/logo/logo.png" style="margin-top: -5px; margin-left: -22px; height: 60px;" alt="materialize logo">
          -->
          <img class="hide-on-small-only" src="../assets/img/logo/logo.png" style="margin-left: -18px; height: 33px;" alt="materialize logo">
      </a><a class="navbar-toggler hide" href="#"><i class="material-icons">radio_button_checked</i></a>
    </h1>
  </div>
  <ul class="sidenav sidenav-collapsible leftside-navigation collapsible sidenav-fixed menu-shadow ps" id="slide-out" data-menu="menu-navigation" data-collapsible="menu-accordion">
    <ng-container *ngFor="let m of pageData.menus; let iM = index;">
      <li *ngIf="m.stauts && m.menus" (click)="menuGroupSelect(m)" class="bold" [ngClass]="{'open': m.active}">
        <a class="collapsible-header waves-cyan" tabindex="0">
          <i class="material-icons">{{m.icon}}</i><span class="menu-title">{{m.title}} {{m.active}}</span>
          <span *ngIf="m.badge" class="badge badge pill orange float-right mr-10">{{m.badge}}</span>
        </a>
        <div class="collapsible-body">
          <ul class="collapsible collapsible-sub" data-collapsible="accordion">
            <li *ngFor="let sm of m.menus" class="active">
              <a class="collapsible-body" [ngClass]="{'active': sm.active}">
                <i class="material-icons">{{sm.icon}}</i><span>{{sm.title}}</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
      <li *ngIf="m.status && !m.menus && !m.header && m.title!='logo'" class="bold" [ngClass]="{'active':m.active}" style="line-height: 1;">
        <div (click)="menuItemSelect(iM)" class="menu-bar-mitem">
          <i class="material-icons" style="margin-bottom: 10px;">{{m.icon}}</i>
          <div>
            <span class="menu-title">{{m.title}}</span>
          </div>
        </div>
        <!-- <a (click)="menuItemSelect(iM)" class="waves-effect waves-cyan" [ngClass]="{'active bold open': m.active}" href="javascript:void(0);">
          <i class="material-icons">{{m.icon}}</i><span class="menu-title">{{m.title}}</span>
        </a> -->
      </li>

      <!-- <li *ngIf="m.title=='logo'" class="bold" style="line-height: 1;">
        <div class="">
          <h1 class="">          
            <a (click)="menuItemSelect(0)" class="brand-logo darken-1" href="javascript:void(0);">
              <img class="hide-on-small-only" src="../assets/img/logo/logox.png" style="margin-left: -1px; height: 33px;" alt="materialize logo">        
            </a>
          </h1>
        </div>
      </li> -->
      
    </ng-container>
  </ul>
  <!-- <div class="brand">
    <h1 class="logo-wrapper">
    
      <a (click)="menuItemSelect(0)" class="brand-logo darken-1" href="javascript:void(0);">
        <img class="hide-on-small-only" src="../assets/img/logo/logox.png" style="margin-left: -18px; height: 33px;" alt="materialize logo">        
      </a>
    </h1>
  </div> -->
  <!-- <ul class="sidenav sidenav-collapsible leftside-navigation collapsible sidenav-fixed menu-shadow ps" id="slide-out" data-menu="menu-navigation" data-collapsible="menu-accordion">
    <li class="active bold open">
      <a class="collapsible-header waves-effect waves-cyan " tabindex="0">
        <i class="material-icons">settings_input_svideo</i><span class="menu-title" data-i18n="">Dashboard</span><span class="badge badge pill orange float-right mr-10">3</span>
      </a>
      <div class="collapsible-body" style="display: block;">
        <ul class="collapsible collapsible-sub" data-collapsible="accordion">
          <li class="active"><a class="collapsible-body active" href="dashboard-modern.html" data-i18n="" style="display: block;"><i class="material-icons">radio_button_unchecked</i><span>Modern</span></a>
          </li>
          <li><a class="collapsible-body" href="dashboard-ecommerce.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>eCommerce</span></a>
          </li>
          <li><a class="collapsible-body" href="dashboard-analytics.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Analytics</span></a>
          </li>
        </ul>
      </div>
    </li>
    <li class="bold"><a class="collapsible-header waves-effect waves-cyan " href="#" tabindex="0"><i class="material-icons">dvr</i><span class="menu-title" data-i18n="">Templates</span></a>
      <div class="collapsible-body">
        <ul class="collapsible collapsible-sub" data-collapsible="accordion">
          <li><a class="collapsible-body collapsible-header waves-effect waves-cyan" href="#" data-i18n="" tabindex="0"><i class="material-icons">radio_button_unchecked</i><span>Vertical</span></a>
            <div class="collapsible-body">
              <ul class="collapsible" data-collapsible="accordion">
                <li><a class="collapsible-body" href="../vertical-modern-menu-template/" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Modern  Menu</span></a>
                </li>
                <li><a class="collapsible-body" href="../vertical-menu-nav-dark-template/" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Navbar Dark</span></a>
                </li>
                <li><a class="collapsible-body" href="../vertical-gradient-menu-template/" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Gradient Menu</span></a>
                </li>
                <li><a class="collapsible-body" href="../vertical-dark-menu-template/" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Dark Menu</span></a>
                </li>
              </ul>
            </div>
          </li>
          <li><a class="collapsible-body collapsible-header waves-effect waves-cyan" href="#" data-i18n="" tabindex="0"><i class="material-icons">radio_button_unchecked</i><span>Horizontal</span></a>
            <div class="collapsible-body">
              <ul class="collapsible" data-collapsible="accordion">
                <li><a class="collapsible-body" href="../horizontal-menu-template/" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Horizontal Menu</span></a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </li>
    <li class="navigation-header"><a class="navigation-header-text">Applications</a><i class="navigation-header-icon material-icons">more_horiz</i>
    </li>
    <li class="bold"><a class="waves-effect waves-cyan " href="app-email.html"><i class="material-icons">mail_outline</i><span class="menu-title" data-i18n="">Mail</span><span class="badge new badge pill pink accent-2 float-right mr-10">5</span></a>
    </li>
    <li class="bold"><a class="waves-effect waves-cyan " href="app-chat.html"><i class="material-icons">chat_bubble_outline</i><span class="menu-title" data-i18n="">Chat</span></a>
    </li>
    <li class="bold"><a class="waves-effect waves-cyan " href="app-todo.html"><i class="material-icons">check</i><span class="menu-title" data-i18n="">ToDo</span></a>
    </li>
    <li class="bold"><a class="waves-effect waves-cyan " href="app-contacts.html"><i class="material-icons">import_contacts</i><span class="menu-title" data-i18n="">Contacts</span></a>
    </li>
    <li class="bold"><a class="waves-effect waves-cyan " href="app-calendar.html"><i class="material-icons">today</i><span class="menu-title" data-i18n="">Calendar</span></a>
    </li>
    <li class="bold"><a class="collapsible-header waves-effect waves-cyan " href="#" tabindex="0"><i class="material-icons">add_shopping_cart</i><span class="menu-title" data-i18n="">eCommerce</span></a>
      <div class="collapsible-body">
        <ul class="collapsible collapsible-sub" data-collapsible="accordion">
          <li><a class="collapsible-body" href="eCommerce-products-page.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Products Page</span></a>
          </li>
          <li><a class="collapsible-body" href="eCommerce-pricing.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Pricing</span></a>
          </li>
          <li><a class="collapsible-body" href="eCommerce-invoice.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Invoice</span></a>
          </li>
        </ul>
      </div>
    </li>
    <li class="navigation-header"><a class="navigation-header-text">Pages </a><i class="navigation-header-icon material-icons">more_horiz</i>
    </li>
    <li class="bold"><a class="collapsible-header waves-effect waves-cyan " href="#" tabindex="0"><i class="material-icons">content_paste</i><span class="menu-title" data-i18n="">Pages</span></a>
      <div class="collapsible-body">
        <ul class="collapsible collapsible-sub" data-collapsible="accordion">
          <li><a class="collapsible-body" href="page-contact.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Contact</span></a>
          </li>
          <li><a class="collapsible-body" href="page-blog-list.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Blog</span></a>
          </li>
          <li><a class="collapsible-body" href="page-search.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Search</span></a>
          </li>
          <li><a class="collapsible-body" href="page-knowledge.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Knowledge</span></a>
          </li>
          <li><a class="collapsible-body" href="page-faq.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>FAQs</span></a>
          </li>
          <li><a class="collapsible-body" href="page-blank.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Page Blank</span></a>
          </li>
        </ul>
      </div>
    </li>
    <li class="bold"><a class="collapsible-header waves-effect waves-cyan " href="#" tabindex="0"><i class="material-icons">crop_original</i><span class="menu-title" data-i18n="">Medias</span></a>
      <div class="collapsible-body">
        <ul class="collapsible collapsible-sub" data-collapsible="accordion">
          <li><a class="collapsible-body" href="media-gallery-page.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Gallery Page</span></a>
          </li>
          <li><a class="collapsible-body" href="media-hover-effects.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Media Hover Effects</span></a>
          </li>
        </ul>
      </div>
    </li>
    <li class="bold"><a class="collapsible-header waves-effect waves-cyan " href="#" tabindex="0"><i class="material-icons">face</i><span class="menu-title" data-i18n="">User</span><span class="badge badge pill purple float-right mr-10">10</span></a>
      <div class="collapsible-body">
        <ul class="collapsible collapsible-sub" data-collapsible="accordion">
          <li><a class="collapsible-body" href="user-profile-page.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>User Profile</span></a>
          </li>
          <li><a class="collapsible-body" href="user-login.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Login</span></a>
          </li>
          <li><a class="collapsible-body" href="user-register.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Register</span></a>
          </li>
          <li><a class="collapsible-body" href="user-forgot-password.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Forgot Password</span></a>
          </li>
          <li><a class="collapsible-body" href="user-lock-screen.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Lock Screen</span></a>
          </li>
        </ul>
      </div>
    </li>
    <li class="bold"><a class="collapsible-header waves-effect waves-cyan " href="#" tabindex="0"><i class="material-icons">filter_tilt_shift</i><span class="menu-title" data-i18n="">Misc</span></a>
      <div class="collapsible-body">
        <ul class="collapsible collapsible-sub" data-collapsible="accordion">
          <li><a class="collapsible-body" href="page-404.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>404</span></a>
          </li>
          <li><a class="collapsible-body" href="page-maintenance.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Page Maintenanace</span></a>
          </li>
          <li><a class="collapsible-body" href="page-500.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>500</span></a>
          </li>
        </ul>
      </div>
    </li>
    <li class="navigation-header"><a class="navigation-header-text">User Interface </a><i class="navigation-header-icon material-icons">more_horiz</i>
    </li>
    <li class="bold"><a class="collapsible-header waves-effect waves-cyan " href="#" tabindex="0"><i class="material-icons">cast</i><span class="menu-title" data-i18n="">Cards</span></a>
      <div class="collapsible-body">
        <ul class="collapsible collapsible-sub" data-collapsible="accordion">
          <li><a class="collapsible-body" href="cards-basic.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Cards</span></a>
          </li>
          <li><a class="collapsible-body" href="cards-advance.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Cards Advance</span></a>
          </li>
          <li><a class="collapsible-body" href="cards-extended.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Cards Extended</span></a>
          </li>
        </ul>
      </div>
    </li>
    <li class="bold"><a class="collapsible-header waves-effect waves-cyan " href="#" tabindex="0"><i class="material-icons">invert_colors</i><span class="menu-title" data-i18n="">CSS</span></a>
      <div class="collapsible-body">
        <ul class="collapsible collapsible-sub" data-collapsible="accordion">
          <li><a class="collapsible-body" href="css-typography.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Typograpy</span></a>
          </li>
          <li><a class="collapsible-body" href="css-color.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Color</span></a>
          </li>
          <li><a class="collapsible-body" href="css-grid.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Grid</span></a>
          </li>
          <li><a class="collapsible-body" href="css-helpers.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Helpers</span></a>
          </li>
          <li><a class="collapsible-body" href="css-media.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Media</span></a>
          </li>
          <li><a class="collapsible-body" href="css-pulse.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Pulse</span></a>
          </li>
          <li><a class="collapsible-body" href="css-sass.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Sass</span></a>
          </li>
          <li><a class="collapsible-body" href="css-shadow.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Shadow</span></a>
          </li>
          <li><a class="collapsible-body" href="css-animations.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Animations</span></a>
          </li>
          <li><a class="collapsible-body" href="css-transitions.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Transitions</span></a>
          </li>
        </ul>
      </div>
    </li>
    <li class="bold"><a class="collapsible-header waves-effect waves-cyan " href="#" tabindex="0"><i class="material-icons">photo_filter</i><span class="menu-title" data-i18n="">Basic UI</span></a>
      <div class="collapsible-body">
        <ul class="collapsible collapsible-sub" data-collapsible="accordion">
          <li><a class="collapsible-body collapsible-header waves-effect waves-cyan" href="#" data-i18n="" tabindex="0"><i class="material-icons">radio_button_unchecked</i><span>Buttons</span></a>
            <div class="collapsible-body">
              <ul class="collapsible" data-collapsible="accordion">
                <li><a class="collapsible-body" href="ui-basic-buttons.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Basic</span></a>
                </li>
                <li><a class="collapsible-body" href="ui-extended-buttons.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Extended</span></a>
                </li>
              </ul>
            </div>
          </li>
          <li><a class="collapsible-body" href="ui-icons.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Icons</span></a>
          </li>
          <li><a class="collapsible-body" href="ui-alerts.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Alerts</span></a>
          </li>
          <li><a class="collapsible-body" href="ui-badges.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Badges</span></a>
          </li>
          <li><a class="collapsible-body" href="ui-breadcrumbs.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Breadcrumbs</span></a>
          </li>
          <li><a class="collapsible-body" href="ui-chips.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Chips</span></a>
          </li>
          <li><a class="collapsible-body" href="ui-collections.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Collections</span></a>
          </li>
          <li><a class="collapsible-body" href="ui-navbar.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Navbar</span></a>
          </li>
          <li><a class="collapsible-body" href="ui-pagination.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Pagination</span></a>
          </li>
          <li><a class="collapsible-body" href="ui-preloader.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Preloader</span></a>
          </li>
        </ul>
      </div>
    </li>
    <li class="bold"><a class="collapsible-header waves-effect waves-cyan " href="#" tabindex="0"><i class="material-icons">settings_brightness</i><span class="menu-title" data-i18n="">Advanced UI</span></a>
      <div class="collapsible-body">
        <ul class="collapsible collapsible-sub" data-collapsible="accordion">
          <li><a class="collapsible-body" href="advance-ui-carousel.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Carousel</span></a>
          </li>
          <li><a class="collapsible-body" href="advance-ui-collapsibles.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Collapsibles</span></a>
          </li>
          <li><a class="collapsible-body" href="advance-ui-toasts.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Toasts</span></a>
          </li>
          <li><a class="collapsible-body" href="advance-ui-tooltip.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Tooltip</span></a>
          </li>
          <li><a class="collapsible-body" href="advance-ui-dropdown.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Dropdown</span></a>
          </li>
          <li><a class="collapsible-body" href="advance-ui-feature-discovery.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Discovery</span></a>
          </li>
          <li><a class="collapsible-body" href="advance-ui-media.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Media</span></a>
          </li>
          <li><a class="collapsible-body" href="advance-ui-modals.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Modals</span></a>
          </li>
          <li><a class="collapsible-body" href="advance-ui-scrollspy.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Scrollspy</span></a>
          </li>
          <li><a class="collapsible-body" href="advance-ui-tabs.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Tabs</span></a>
          </li>
          <li><a class="collapsible-body" href="advance-ui-waves.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Waves</span></a>
          </li>
        </ul>
      </div>
    </li>
    <li class="bold"><a class="collapsible-header waves-effect waves-cyan " href="#" tabindex="0"><i class="material-icons">add_to_queue</i><span class="menu-title" data-i18n="">Extra Components</span></a>
      <div class="collapsible-body">
        <ul class="collapsible collapsible-sub" data-collapsible="accordion">
          <li><a class="collapsible-body" href="extra-components-range-slider.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Range Slider</span></a>
          </li>
          <li><a class="collapsible-body" href="extra-components-sweetalert.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Sweetalert</span></a>
          </li>
          <li><a class="collapsible-body" href="extra-components-nestable.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Nestable</span></a>
          </li>
          <li><a class="collapsible-body" href="extra-components-translation.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Translation</span></a>
          </li>
          <li><a class="collapsible-body" href="extra-components-highlight.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Highlight</span></a>
          </li>
        </ul>
      </div>
    </li>
    <li class="navigation-header"><a class="navigation-header-text">Tables &amp; Forms </a><i class="navigation-header-icon material-icons">more_horiz</i>
    </li>
    <li class="bold"><a class="waves-effect waves-cyan " href="table-basic.html"><i class="material-icons">border_all</i><span class="menu-title" data-i18n="">Basic Tables</span></a>
    </li>
    <li class="bold"><a class="waves-effect waves-cyan " href="table-data-table.html"><i class="material-icons">grid_on</i><span class="menu-title" data-i18n="">Data Tables</span></a>
    </li>
    <li class="bold"><a class="collapsible-header waves-effect waves-cyan " href="#" tabindex="0"><i class="material-icons">chrome_reader_mode</i><span class="menu-title" data-i18n="">Forms</span></a>
      <div class="collapsible-body">
        <ul class="collapsible collapsible-sub" data-collapsible="accordion">
          <li><a class="collapsible-body" href="form-elements.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Form Elements</span></a>
          </li>
          <li><a class="collapsible-body" href="form-validation.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Form Validation</span></a>
          </li>
          <li><a class="collapsible-body" href="form-masks.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Form Masks</span></a>
          </li>
          <li><a class="collapsible-body" href="form-file-uploads.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>File Uploads</span></a>
          </li>
        </ul>
      </div>
    </li>
    <li class="bold"><a class="waves-effect waves-cyan " href="form-layouts.html"><i class="material-icons">image_aspect_ratio</i><span class="menu-title" data-i18n="">Form Layouts</span></a>
    </li>
    <li class="bold"><a class="waves-effect waves-cyan " href="form-wizard.html"><i class="material-icons">settings_ethernet</i><span class="menu-title" data-i18n="">Form Wizard</span></a>
    </li>
    <li class="navigation-header"><a class="navigation-header-text">Charts &amp; Maps </a><i class="navigation-header-icon material-icons">more_horiz</i>
    </li>
    <li class="bold"><a class="collapsible-header waves-effect waves-cyan " href="#" tabindex="0"><i class="material-icons">pie_chart_outlined</i><span class="menu-title" data-i18n="">Chart</span></a>
      <div class="collapsible-body">
        <ul class="collapsible collapsible-sub" data-collapsible="accordion">
          <li><a class="collapsible-body" href="charts-chartjs.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>ChartJS</span></a>
          </li>
          <li><a class="collapsible-body" href="charts-chartist.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Chartist</span></a>
          </li>
          <li><a class="collapsible-body" href="charts-sparklines.html" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Sparkline Charts</span></a>
          </li>
        </ul>
      </div>
    </li>
    <li class="navigation-header"><a class="navigation-header-text">Misc </a><i class="navigation-header-icon material-icons">more_horiz</i>
    </li>
    <li class="bold"><a class="collapsible-header waves-effect waves-cyan " href="#" tabindex="0"><i class="material-icons">photo_filter</i><span class="menu-title" data-i18n="">Menu levels</span></a>
      <div class="collapsible-body">
        <ul class="collapsible collapsible-sub" data-collapsible="accordion">
          <li><a class="collapsible-body" href="#" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Second level</span></a>
          </li>
          <li><a class="collapsible-body collapsible-header waves-effect waves-cyan" href="#" data-i18n="" tabindex="0"><i class="material-icons">radio_button_unchecked</i><span>Second level child</span></a>
            <div class="collapsible-body">
              <ul class="collapsible" data-collapsible="accordion">
                <li><a class="collapsible-body" href="#" data-i18n=""><i class="material-icons">radio_button_unchecked</i><span>Third level</span></a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </li>
    <li class="bold"><a class="waves-effect waves-cyan " href="changelog.html"><i class="material-icons">track_changes</i><span class="menu-title" data-i18n="">Changelog</span><span class="badge badge pill light-blue float-right mr-10">5.1</span></a>
    </li>
    <li class="bold"><a class="waves-effect waves-cyan " href="../../../documentation/index.html"><i class="material-icons">import_contacts</i><span class="menu-title" data-i18n="">Documentation</span></a>
    </li>
    <li class="bold"><a class="waves-effect waves-cyan " href="https://pixinvent.ticksy.com/"><i class="material-icons">help_outline</i><span class="menu-title" data-i18n="">Support</span></a>
    </li>
  </ul> -->
  <div class="navigation-background"></div><a class="hide sidenav-trigger btn-sidenav-toggle btn-floating btn-medium waves-effect waves-light hide-on-large-only" href="#" data-target="slide-out"><i class="material-icons">menu</i></a>
</aside>
<div id="main">
  <div class="row">
    <div class="content-wrapper-before blue darken-4 tatt-top-sbar"></div>
    <div class="breadcrumbs-dark pb-0 pt-1" id="breadcrumbs-wrapper">
      <!-- Search for small screen-->
      <div class="container" *ngIf="pageData.menus && pageData.menus.length>0">
        <div class="row">
          <div class="col s10 m6 l6">
            <h5 class="breadcrumbs-title mt-0 mb-0"><i class="material-icons hide" style="opacity:0.4;">{{pageData.menus[pageData.menuIndex].icon}}</i>
              <div style="display:inline-block;">{{pageData.menus[pageData.menuIndex].title}}</div>
            </h5>
            <ol class="breadcrumbs mb-0" *ngIf="pageData.menus[pageData.menuIndex].title != 'Home'">
              <li class="breadcrumb-item"><a (click)="menuItemSelect(0)" href="javascript:void(0)" class="tatt-a-home">Home</a></li>
              <!-- <li class="breadcrumb-item"><a href="#">Basic UI</a></li> -->
              <li class="breadcrumb-item active tatt-a-active">{{pageData.menus[pageData.menuIndex].title}}</li>
            </ol>
          </div>
          <div class="col s2 m6 l6 hide"><a class="btn dropdown-settings waves-effect waves-light breadcrumbs-btn right" href="#!" data-target="dropdown1"><i class="material-icons hide-on-med-and-up">settings</i><span class="hide-on-small-onl">Settings</span><i class="material-icons right">arrow_drop_down</i></a><ul class="dropdown-content" id="dropdown1" tabindex="0">
              <li tabindex="0"><a class="grey-text text-darken-2" href="user-profile-page.html">Profile<span class="new badge red">2</span></a></li>
              <li tabindex="0"><a class="grey-text text-darken-2" href="app-contacts.html">Contacts</a></li>
              <li tabindex="0"><a class="grey-text text-darken-2" href="page-faq.html">FAQ</a></li>
              <li class="divider" tabindex="-1"></li>
              <li tabindex="0"><a class="grey-text text-darken-2" href="user-login.html">Logout</a></li>
            </ul>
          </div>
          <div class="col s2 m6 16 right-align">
            <!-- Modal Trigger -->
            <a class="modal-trigger" href="#modal1">
              <span *ngIf="sensorG.length>0" class="badge tatt-green">{{sensorG.length}}</span>
              <span *ngIf="sensorY.length>0" class="badge tatt-yellow">{{sensorY.length}}</span>
              <span *ngIf="sensorO.length>0" class="badge tatt-orange">{{sensorO.length}}</span>
              <span *ngIf="sensorR.length>0" class="badge tatt-red">{{sensorR.length}}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col s12">
      <div class="container">
        <div class="section">
          <div class="card">
            <div class="card-content">
              <router-outlet></router-outlet>
            </div>
          </div>
  <!--Icon Sizes-->
  <div class="row hide">
      <div class="col s12 m12 l12">
          <div id="icon-sizes" class="card card-default">
              <div class="card-content">
                  <h4 class="card-title">Usage</h4>
                  <div class="row">
                      <div class="col s12">
                          <p>To be able to use these icons, you must include this line in the <code class=" language-markup"><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>head</span><span class="token punctuation">&gt;</span></span></code>portion
                              of your HTML code</p>
                          <pre class=" language-markup"><code class=" language-markup"><span class="token lf">
</span>            <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>link</span> <span class="token attr-name">href</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>https://fonts.googleapis.com/icon?family<span class="token punctuation">=</span>Material+Icons<span class="token punctuation">"</span></span> <span class="token attr-name">rel</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>stylesheet<span class="token punctuation">"</span></span><span class="token punctuation">&gt;</span></span></code></pre>
                          <p>To use these icons, use the material-icons class on an element and provide the ligature
                              as the text content.</p>
                          <pre class=" language-markup"><code class=" language-markup"><span class="token lf">
</span>            <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>i</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>material-icons<span class="token punctuation">"</span></span><span class="token punctuation">&gt;</span></span>add<span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>i</span><span class="token punctuation">&gt;</span></span><span class="token lf">
</span>            </code></pre>
                      </div>
                  </div>
                  <h4 class="card-title">Sizes</h4>
                  <div class="row">
                      <div class="col s12">
                          <p>To control the size of the icon, change the <code class="  language-css"><span class="token property">font-size</span><span class="token punctuation">:</span> 30px</code> property of your icon.
                              Optionally you can use preset classes as shown below.</p>
                      </div>
                      <div class="col s12">
                          <div class="card-panel">
                              <div class="row">
                                  <div class="center-align">
                                      <div class="col s3">
                                          <i class="material-icons tiny icon-demo">insert_chart</i>
                                          <br>
                                          <p>Tiny</p>
                                      </div>
                                      <div class="col s3">
                                          <i class="material-icons small icon-demo">insert_chart</i>
                                          <br>
                                          <p>Small</p>
                                      </div>
                                      <div class="col s3">
                                          <i class="material-icons medium icon-demo">insert_chart</i>
                                          <br>
                                          <p>Medium</p>
                                      </div>
                                      <div class="col s3">
                                          <i class="material-icons large icon-demo">insert_chart</i>
                                          <br>
                                          <p>Large</p>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- Icon Listing -->
  <!--action-icons-->
  <div class="row hide">
      <div class="col s12 m12 l12">
          <div id="action" class="card card-default icon-container">
              <div class="card-content">
                  <div class="row">
                      <div class="col s12 m12 l12">
                          <h4 class="card-title">Action</h4>
                      </div>
                  </div>
                  <div class="row">
                      
                  </div>
              </div>
          </div>
      </div>
  </div>
</div><!-- START RIGHT SIDEBAR NAV -->
<aside id="right-sidebar-nav">
 <div id="slide-out-right" class="slide-out-right-sidenav sidenav rightside-navigation right-aligned" style="transform: translateX(105%);">
    <div class="row">
       <div class="slide-out-right-title">
          <div class="col s12 border-bottom-1 pb-0 pt-1">
             <div class="row">
                <div class="col s2 pr-0 center">
                   <i class="material-icons vertical-text-middle"><a href="#" class="sidenav-close">clear</a></i>
                </div>
                <div class="col s10 pl-0">
                   <ul class="tabs">
                      <li class="tab col s4 p-0">
                         <a href="#messages" class="active">
                            <span>Messages</span>
                         </a>
                      </li>
                      <li class="tab col s4 p-0">
                         <a href="#settings">
                            <span>Settings</span>
                         </a>
                      </li>
                      <li class="tab col s4 p-0">
                         <a href="#activity">
                            <span>Activity</span>
                         </a>
                      </li>
                   <li class="indicator" style="left: 0px; right: 188px;"></li></ul>
                </div>
             </div>
          </div>
       </div>
    </div>
 </div>

</aside>
<!-- END RIGHT SIDEBAR NAV -->
          <div style="bottom: 50px; right: 19px;" class="fixed-action-btn direction-top hide">
            <a class="btn-floating btn-large gradient-45deg-light-blue-cyan gradient-shadow"><i class="material-icons">add</i></a>
            <ul>
                <li><a href="css-helpers.html" class="btn-floating blue"><i class="material-icons">help_outline</i></a></li>
                <li><a href="cards-extended.html" class="btn-floating green"><i class="material-icons">widgets</i></a></li>
                <li><a href="app-calendar.html" class="btn-floating amber"><i class="material-icons">today</i></a></li>
                <li><a href="app-email.html" class="btn-floating red"><i class="material-icons">mail_outline</i></a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal Structure -->
  <div id="modal1" class="modal">
    <div class="modal-content">
      <div class="row">
        <div class="col s8">
          <h4>Sensor Status</h4>
        </div>
        <div class="col s4">
          <p>
            <!-- {{sensorR.length}} OFFLINE. {{sensorG.length}} ONLINE. -->
            <span *ngIf="sensorG.length>0" class="badge tatt-green">{{sensorG.length}}</span>
            <span *ngIf="sensorY.length>0" class="badge tatt-yellow">{{sensorY.length}}</span>
            <span *ngIf="sensorO.length>0" class="badge tatt-orange">{{sensorO.length}}</span>
            <span *ngIf="sensorR.length>0" class="badge tatt-red">{{sensorR.length}}</span>
          </p>
        </div>
      </div>
      <table>
        <tr *ngFor="let sR of sensorR; let iSR=index;">
          <td><span class="badge tatt-red">{{iSR+1}}</span></td>
          <td>{{sR.sensor.sensorUuid}}</td>
          <td>{{sR.timestamp | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
          <td style="padding:2px 15px;" class="center-align">
            <a [href]="sR.imgUrl" target="_blank" title="UTC: {{sR.imageTimestampUtc}}">
              <img [src]="sR.imgUrl" style="max-width: 80px;" />
            </a>
          </td>
        </tr>
        <tr *ngFor="let sR of sensorO; let iSR=index;">
          <td><span class="badge tatt-orange">{{iSR+1}}</span></td>
          <td>{{sR.sensor.sensorUuid}}</td>
          <td>{{sR.timestamp | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
          <td style="padding:2px 15px;" class="center-align">
            <a [href]="sR.imgUrl" target="_blank" title="UTC: {{sR.imageTimestampUtc}}">
              <img [src]="sR.imgUrl" style="max-width: 80px;" />
            </a>
          </td>
        </tr>
        <tr *ngFor="let sR of sensorY; let iSR=index;">
          <td><span class="badge tatt-yellow">{{iSR+1+sensorO.length}}</span></td>
          <td>{{sR.sensor.sensorUuid}}</td>
          <td>{{sR.timestamp | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
          <td style="padding:2px 15px;" class="center-align">
            <a [href]="sR.imgUrl" target="_blank" title="UTC: {{sR.imageTimestampUtc}}">
              <img [src]="sR.imgUrl" style="max-width: 80px;" />
            </a>
          </td>
        </tr>
        <tr *ngFor="let sG of sensorG; let iSG=index;">
          <td><span class="badge tatt-green">{{iSG+1+sensorO.length+sensorY.length}}</span></td>
          <td>{{sG.sensor.sensorUuid}}</td>
          <td>{{sG.timestamp | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
          <td style="padding:2px 15px;" class="center-align">
            <a *ngIf="showSensorImage" [href]="sG.imgUrl" target="_blank" title="UTC: {{sG.imageTimestampUtc}}">
              <img [src]="sG.imgUrl" style="max-width: 80px;" />
            </a>
          </td>
        </tr>
      </table>
    </div>
    <div class="modal-footer">
      <a href="#!" class="modal-close waves-effect waves-green btn-flat">Close</a>
    </div>
  </div>
</ng-container>
